/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
    // Add custom code below this line

    // Emit an event to indicate the page was restored from bfcache, https://web.dev/articles/bfcache
    window.addEventListener('pageshow', (evt) => {
        if (evt.persisted) {
            document.dispatchEvent(new CustomEvent('on:bfcache:load-restore'));
        }
    });

    //All external links open in new tab
    document.addEventListener('click', (evt) => {
        const link =
            evt.target.tagName === 'A' ? evt.target : evt.target.closest('a');
        if (
            link &&
            link.tagName === 'A' &&
            window.location.hostname !== new URL(link.href).hostname
        ) {
            link.target = '_blank';
        }
    });

    // Ensure anchor scrolling is smooth (it shouldn't be added in the CSS)
    document.addEventListener('click', (evt) => {
        if (
            evt.target.tagName === 'A' &&
            window.location.hostname === new URL(evt.target.href).hostname &&
            evt.target.href.includes('#')
        ) {
            document.getElementsByTagName('html')[0].style.scrollBehavior =
                'smooth';
            setTimeout(() => {
                document.getElementsByTagName('html')[0].style.scrollBehavior =
                    '';
            }, 1000);
        }
    });

    //Track Klaviyo ATC
    window.addEventListener('load', function () {
        var _learnq = window._learnq || [];
        function addedToCart() {
            fetch(`${window.location.origin}/cart.js`).then((res) =>
                res
                    .clone()
                    .json()
                    .then((data) => {
                        var cart = {
                            total_price: data.total_price / 100,
                            $value: data.total_price / 100,
                            total_discount: data.total_discount,
                            original_total_price:
                                data.original_total_price / 100,
                            items: data.items
                        };
                        if (item !== 'undefined') {
                            cart = Object.assign(cart, item);
                        }
                        if (klAjax) {
                            _learnq.push(['track', 'Added to Cart', cart]);
                            klAjax = false;
                        }
                    })
            );
        }
        (function (ns, fetch) {
            ns.fetch = function () {
                const response = fetch.apply(this, arguments);
                response.then((res) => {
                    if (
                        `${window.location.origin}/cart/add.js`.includes(
                            res.url
                        ) &&
                        res.url !== ''
                    ) {
                        addedToCart();
                    }
                });
                return response;
            };
        })(window, window.fetch);
        var klAjax = true;
        var atcButtons = document.querySelectorAll(
            "form[action*='/cart/add'] button[type='submit']"
        );
        for (var i = 0; i < atcButtons.length; i++) {
            atcButtons[i].addEventListener('click', function () {
                if (klAjax) {
                    _learnq.push(['track', 'Added to Cart', item]);
                    klAjax = false;
                }
            });
        }
    });

    //Fix search moved
    document.querySelectorAll('[data-search-proxy]').forEach((el) => {
        const popdownEl = document.querySelector(
            'header-search-popdown summary'
        );
        el.addEventListener('click', () => {
            popdownEl.click();
        });
    });

    //Fix two sort input locations
    document.querySelectorAll('[data-sort-link-proxy]').forEach((el) => {
        el.addEventListener('click', (e) => {
            const value = el.dataset.value;

            const inputEl = document.querySelector(
                `input[type="radio"][name="sort_by"][value="${value}"]`
            );

            inputEl.checked = true;
        });
    });

    class InfinteScroll extends HTMLElement {
        constructor() {
            super();
            document.addEventListener(
                'on:bfcache:load-restore',
                this.reload.bind(this)
            );
        }

        get nextPageUrl() {
            return this.paginationContainer.querySelector(
                '.pagination-custom__next'
            )?.href;
        }

        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            this.destroy();
        }

        init() {
            this.productGrid = this.querySelector('.grid');
            this.paginationContainer = this.querySelector('.pagination-custom');
            if (!this.paginationContainer) return;
            this.results = this.productGrid.querySelectorAll('.product-item');

            this.resultClickHandler =
                this.resultClickHandler ||
                this.handleProductLinkClick.bind(this);
            this.addEventListener('click', this.resultClickHandler);
            this.controller = null;

            this.paginationObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            this.loadNextPage();

                            this.intersectingTimer = setInterval(
                                this.loadNextPage.bind(this),
                                1000
                            );
                        } else if (this.intersectingTimer) {
                            clearInterval(this.intersectingTimer);
                        }
                    });
                },
                { rootMargin: `${window.innerHeight * 1.5}px 0px` }
            );

            this.paginationObserver.observe(this.paginationContainer);
        }

        handleProductLinkClick(evt) {
            //if its in a grid and a link
            if (
                evt.target.closest('a') &&
                evt.target.closest('.grid') &&
                this.controller
            ) {
                this.controller.abort();
            }
        }

        reload() {
            this.destroy();
            this.init();
        }

        async loadNextPage() {
            if (!this.nextPageUrl) {
                console.warn(
                    'no nextpage url found, destroying infinite scroll'
                );

                this.paginationContainer.classList.add('hidden');

                return this.destroy();
            }

            if (!this.isFetching) {
                this.isFetching = true;
                this.controller = new AbortController();
                try {
                    /* this.classList.add('is-loading'); */
                    const tmpl = await this.fetchNextPageTemplate();
                    this.appendProductsFromTemplate(tmpl);
                    this.updatePagination(tmpl);
                } catch (error) {
                    console.log('Unable to fetch next page of results', error);
                    if (this.intersectingTimer)
                        clearInterval(this.intersectingTimer);
                } finally {
                    /* this.classList.remove('is-loading'); */
                    this.isFetching = false;
                }
            }
        }

        async fetchNextPageTemplate() {
            const response = await fetch(this.nextPageUrl, {
                signal: this.controller.signal
            });

            if (!response.ok) throw new Error(response.status);

            const tmpl = document.createElement('template');
            tmpl.innerHTML = await response.text();

            return tmpl;
        }

        appendProductsFromTemplate(tmpl) {
            let newResultsHtml = '';
            const lastResult = this.results[this.results.length - 1];
            tmpl.content.querySelectorAll('.product-item').forEach((result) => {
                newResultsHtml += result.outerHTML;
            });
            lastResult.insertAdjacentHTML('afterend', newResultsHtml);
            this.results = this.productGrid.querySelectorAll('.product-item');
        }

        updatePagination(tmpl) {
            const templatePagination =
                tmpl.content.querySelector('.pagination-custom');

            this.paginationContainer.innerHTML =
                templatePagination.innerHTML || '';
        }

        destroy() {
            if (this.intersectingTimer) clearInterval(this.intersectingTimer);
            if (this.paginationObserver) this.paginationObserver.disconnect();
            this.removeEventListener('click', this.resultClickHandler);
            this.loadMoreClickHandler = null;
        }
    }

    customElements.define('infinite-scroll', InfinteScroll);

    //Sticky ATC
    document.addEventListener('DOMContentLoaded', () => {
        console.log('sticky atc');
        if (window.innerWidth < 749) {
            const stickyAtcEl = document.querySelector('[data-sticky-atc]');
            console.log('stickyAtcEl', stickyAtcEl);

            if (!stickyAtcEl) return;

            //intersectionobserver which adds class sticky-atc when its not visible
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    console.log('entry.isIntersecting', entry.isIntersecting);

                    if (!entry.isIntersecting) {
                        stickyAtcEl.classList.add('sticky-atc');
                    } else {
                        stickyAtcEl.classList.remove('sticky-atc');
                    }
                });
            });

            observer.observe(stickyAtcEl.parentElement);
        }
    });
})();
